import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { setResponsiveImage } from "../../helpers";
import "./index.scss";

interface StatisticsBanner {
  transitionDelay?: number;
  stats: statsDataItem[];
  headerBanner?: null | {
    heading?: string;
    backgroundImageDesktop?: string;
    backgroundImageMobile?: string;
  };
}

interface statsDataItem {
  key?: number;
  unit?: string;
  percentage: number;
  value?: number;
  description: string;
}

export default ({
  transitionDelay = 5,
  stats,
  headerBanner = {
    heading: "The ITF Player Pathway and Success Stories"
  }
}: StatisticsBanner) => {
  const statsData = stats.map((d, key) => ({ ...d, key: key + 1 }));
  let [currentStat, updateCurrentStat] = useState(statsData[0]);
  let [firstCount, updateFirstCount] = useState<boolean>(true);
  const length = stats.length;
  const { description, value, unit, key, percentage } = currentStat;
  const CSSProperty = `
    @property --percent {
      syntax: "<percentage>";
      initial-value: 0%;
      inherits: false
    }
  `;
  const keyFrameCSSAnimition = `
        .statistic-banner__chart .pie-chart {
            animation: conic-gradient--${key} ${
    key === 0 ? ".5" : "1"
  }s ease-out ${firstCount ? "1s" : "0s"} 1 none running;
            animation-fill-mode: forwards;
        }
        .statistic-banner__label {
            animation: conic-gradient--${key} ${
    key === 0 ? ".5" : "1"
  }s ease-out 0s 1 none running;
            animation-fill-mode: forwards;
        }
        @keyframes conic-gradient--${key} {
            from {
                --percent: 0%;
                --opacity: 0;
                --angle: 0deg;
                --textSize: 21px;
            }

            to {
                --percent: ${percentage}%;
                --opacity: 1;
                --angle: 180deg;
                --textSize: 28px;
            }
        }
        @keyframes conic-gradient--0 {
            from {
                --percent: ${percentage}%;
                --opacity: 1;
                --angle: 180deg;
                --textSize: 28px;
            }

            to {
                --percent: 0%;
                --opacity: 0;
                --angle: 720deg;
                --textSize: 21px;
            }
        }
    `;

  useEffect(() => {
    const head = document.querySelector("head");
    let interval: ReturnType<typeof setInterval>;
    let intervalReset: ReturnType<typeof setInterval>;

    if (head !== null) {
      var styleNode = document.createElement("style");
      var otherStyleNode = document.createElement("style");
      styleNode.id = "stats";
      styleNode.innerHTML = keyFrameCSSAnimition;
      otherStyleNode.innerHTML = CSSProperty;
      if (document) {
        head.appendChild(styleNode);
        head.appendChild(otherStyleNode);
      }
    }

    setResponsiveImage({
      mobileImage: headerBanner && headerBanner.backgroundImageMobile,
      desktopImage: headerBanner && headerBanner.backgroundImageDesktop,
      tabletImage: headerBanner && headerBanner.backgroundImageDesktop,
      elClassName: "landing-page__tile-bg"
    });

    if (length > 1) {
      let key: number = 1;
      setTimeout(() => {
        interval = setInterval(() => {
          key = key < length ? ++key : 1;
          updateCurrentStat(statsData[key - 1]);
        }, 1000 * transitionDelay);
      }, 500);
      intervalReset = setInterval(() => {
        updateCurrentStat({ ...statsData[key - 1], key: 0 });
      }, 1000 * transitionDelay);
    }

    updateFirstCount(false);

    return () => {
      clearInterval(interval);
      clearInterval(intervalReset);
    };
  }, []);

  useEffect(() => {
    const stats = document.querySelector("#stats");
    if (stats !== null) {
      stats.innerHTML = keyFrameCSSAnimition;
    }
  }, [currentStat]);

  return (
    <>
      <section className="page-section theme version__2 statistic-banner-wrapper landing-page__tile-bg left">
        <div className="page-section__inner">
          <div className="landing-page__tile-bg-text">
            {headerBanner && headerBanner.heading && (
              <strong>{headerBanner.heading}</strong>
            )}
          </div>
        </div>
      </section>
      <div className="page-section statistic-banner__wrapper">
        <div className="page-section__inner">
          <div className="statistic-banner">
            <span className="statistic-banner__label">{description}</span>
            <div className="statistic-banner__chart">
              <span className="statistic-banner__chart-graph"></span>
              <span className="statistic-banner__chart-value">
                <CountUp
                  start={0}
                  end={value ? value : percentage}
                  duration={1}
                  delay={firstCount ? 1 : 0}
                />
                {`${unit}`}
              </span>
              <div className={`pie-chart ${key}`}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
